<template>
  <svg
    :class="customClass"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path xmlns="http://www.w3.org/2000/svg" d="M4.30775 20.5C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V8.30775C2.5 7.80258 2.675 7.375 3.025 7.025C3.375 6.675 3.80258 6.5 4.30775 6.5H8.5V4.80775C8.5 4.30258 8.675 3.875 9.025 3.525C9.375 3.175 9.80258 3 10.3078 3H13.6923C14.1974 3 14.625 3.175 14.975 3.525C15.325 3.875 15.5 4.30258 15.5 4.80775V6.5H19.6923C20.1974 6.5 20.625 6.675 20.975 7.025C21.325 7.375 21.5 7.80258 21.5 8.30775V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.30775ZM10 6.5H14V4.80775C14 4.73075 13.9679 4.66025 13.9038 4.59625C13.8398 4.53208 13.7692 4.5 13.6923 4.5H10.3078C10.2308 4.5 10.1603 4.53208 10.0963 4.59625C10.0321 4.66025 10 4.73075 10 4.80775V6.5ZM20 14.75H14.5V16.5H9.5V14.75H4V18.6923C4 18.7692 4.03208 18.8398 4.09625 18.9038C4.16025 18.9679 4.23075 19 4.30775 19H19.6923C19.7693 19 19.8398 18.9679 19.9038 18.9038C19.9679 18.8398 20 18.7692 20 18.6923V14.75ZM11 15H13V13H11V15ZM4 13.25H9.5V11.5H14.5V13.25H20V8.30775C20 8.23075 19.9679 8.16025 19.9038 8.09625C19.8398 8.03208 19.7693 8 19.6923 8H4.30775C4.23075 8 4.16025 8.03208 4.09625 8.09625C4.03208 8.16025 4 8.23075 4 8.30775V13.25Z" fill="#1E264C"/>
  </svg>
</template>

<script>
export default {
  name: "ToolBoxIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
